import React, { useRef } from 'react';

import useScrollShadows from '~/hooks/useScrollShadows';

type IProps = {
  className?: string;
  children: React.ReactNode;
};

const ScrollShadowContainer: React.FC<IProps> = ({ className, children }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useScrollShadows(containerRef);

  return (
    <div className={className} ref={containerRef}>
      {children}
    </div>
  );
};

export default React.memo(ScrollShadowContainer);
